import { FormControl, InputLabel, MenuItem, Select, useTheme } from '@mui/material';

interface FilterSelectFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  hasValue?: boolean;
  options: Array<{ value: string; label: string }>;
  allOptionLabel?: string;
}

const FilterSelectField = ({
  label,
  value,
  onChange,
  hasValue,
  options,
  allOptionLabel = `All ${label}`,
}: FilterSelectFieldProps) => {
  const theme = useTheme();

  return (
    <FormControl fullWidth size="small" margin="dense">
      <InputLabel
        shrink
        sx={{
          fontSize: '0.75rem',
          color: hasValue ? theme.palette.primary.main : undefined,
          fontWeight: hasValue ? 600 : 400,
        }}
      >
        {label}
      </InputLabel>
      <Select
        value={value}
        label={label}
        onChange={e => onChange(e.target.value)}
        notched
        displayEmpty
        renderValue={selected => {
          if (selected === '') {
            return allOptionLabel;
          }
          const option = options.find(opt => opt.value === selected);
          return option?.label || '';
        }}
        sx={{
          fontSize: '0.75rem',
          '.MuiSelect-select': {
            fontSize: '0.75rem',
          },
          backgroundColor: hasValue ? theme.palette.primary.light + '20' : 'transparent',
          '& fieldset': {
            borderColor: hasValue ? theme.palette.primary.main : undefined,
            borderWidth: hasValue ? '2px' : '1px',
          },
          '&:hover fieldset': {
            borderColor: hasValue ? theme.palette.primary.main : undefined,
          },
          '&.Mui-focused fieldset': {
            borderColor: hasValue ? theme.palette.primary.main : undefined,
          },
        }}
        MenuProps={{
          slotProps: {
            paper: {
              sx: {
                '& .MuiMenuItem-root': {
                  fontSize: '0.75rem',
                },
              },
            },
          },
        }}
      >
        <MenuItem value="">{allOptionLabel}</MenuItem>
        {options.map(option => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default FilterSelectField;
